

 import {
  ButtonConsent,
  EmailConsent,
  UserName,
  Unsubscribe,
  NoActionConsent,
  CampaignUnsubscribe,
  SignUp,
  NoActionUnsubscribe,
  EmailConsentWithHpr,
  DynamicLink,
} from "./ReactComponentsPlugin";

export const components = {
  ButtonConsent,
  EmailConsent,
  UserName,
  Unsubscribe,
  NoActionConsent,
  CampaignUnsubscribe,
  SignUp,
  NoActionUnsubscribe,
  EmailConsentWithHpr,
  DynamicLink,
};
 